import { CANARY_PROD, CANARY_TEST } from '@/helpers/constants/thirdParty';

/* Verifies whether an account is a test account.
If so, calls to certain third-party plugins, such as Mixpanel, will be ignored */

export const isNotTestAccount = (userId) => !window.navigator.userAgent.endsWith('AWS-Canary')
  && !window.navigator.userAgent.endsWith('AWS-Canary-Noscript')
  && !(['app.datapeople.io', 'test-app.taprecruit.co'].includes(window.location.hostname) && userId === CANARY_PROD)
  && !(['testing.iapp.datapeople.io'].includes(window.location.hostname) && userId === CANARY_TEST);
